import { getCookie } from '@/utils/cookieStorage';

export const getReferrer = () => {
  return localStorage.getItem('referrer');
};

export const setReferrer = (route) => {
  let referrer = document.referrer;

  if (route?.query?.ref) {
    referrer = route?.query?.ref;
  }

  if ((!referrer || referrer === '') && getCookie('referrer')) {
    referrer = getCookie('referrer');
  }

  if (referrer && referrer !== '') {
    localStorage.setItem('referrer', referrer);
  }
};
